import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { api } from "../utils/apiHelper";
import "../styles/FundStripe.css";

const FundStripe = ({ authUser, onPaymentSuccess }) => {
  const images = {
    back: "/midBack.png"
  };

  const stripe = useStripe();
  const elements = useElements();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [processing, setProcessing] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount) || numericAmount <= 0) {
      setError("Please enter a valid donation amount.");
      return;
    }

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    setProcessing(true);
    setError(null);

    try {
      const cents = Math.round(numericAmount * 100);
      const payload = {
        amount: cents,
        userId: authUser?._id || null,
        email,
        donorName: name,
        message: message.trim()
      };

      const response = await api("/create-fundraiser-intent", "POST", payload);

      if (!response?.clientSecret) {
        setError("Unable to initialize donation payment.");
        setProcessing(false);
        return;
      }

      const cardElement = elements.getElement(CardElement);
      const result = await stripe.confirmCardPayment(response.clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name,
            email
          },
        },
      });

      if (result.error) {
        setError(result.error.message);
      } else if (result.paymentIntent.status === "succeeded") {
  setSucceeded(true);

  setName("");
  setEmail("");
  setAmount("");
  setMessage("");

   cardElement.clear();

  if (onPaymentSuccess) onPaymentSuccess(result.paymentIntent);
}
    } catch (err) {
      console.error("Donation payment error:", err);
      setError("An error occurred while processing the donation.");
    } finally {
      setProcessing(false);
    }
  };

  const handlePresetClick = (value) => {
    setAmount(value.toString());
  };

  return (
  <form
  onSubmit={handleSubmit}
  className="fund-form"
  style={{
    backgroundImage: `url(${images.back})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "12px",
    padding: "2rem",
    color: "#fff",
    position: "relative",
    overflow: "hidden"
  }}
>
  <div
    style={{
      position: "absolute",
      inset: 0,
      background: "rgba(0, 0, 0, 0)",
      borderRadius: "12px",
      zIndex: 1
    }}
  />
  <div style={{ position: "relative", zIndex: 2 }}>
    <h3>Live Action Campaign</h3>
     <div
      className="preset-buttons"
      style={{
        display: "flex",
        gap: "0.5rem",
        marginBottom: "1rem",
        flexWrap: "wrap"
      }}
    >
      {[5, 25, 50].map((val) => (
        <button
          key={val}
          type="button"
          onClick={() => handlePresetClick(val)}
          className="preset-button"
          style={{
            padding: "0.5rem 1rem",
            borderRadius: "6px",
            border: "none",
            color: "#ff6600",
            cursor: "pointer",
            minWidth: "60px",
            fontWeight: "bold"
          }}
        >
          ${val}
        </button>
      ))}

      <input
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder="Custom"
        min="1"
        className="preset-input"
        style={{
          padding: "0.5rem .5rem",
          borderRadius: "6px",
          background: "#fff",
          color: "#000",
          fontWeight: "bold",
          textAlign: "center"
        }}
      />
    </div>

    <input
      type="text"
      value={name}
      onChange={(e) => setName(e.target.value)}
      placeholder="Name on card"
      className="stripe-pay-form-input"
      required
    />

    <input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Your email"
      className="stripe-pay-form-input"
      required
    />

    <textarea
      value={message}
      onChange={(e) => setMessage(e.target.value.slice(0, 180))}
      placeholder="Leave a message (max 180 characters)"
      className="stripe-pay-form-input"
      rows="3"
      maxLength="180"
    />

    <CardElement className="CardElement" />

    <button
      type="submit"
      className="fund-form-button"
      disabled={processing || succeeded}
    >
      {processing ? "Processing..." : `Donate $${amount || "0.00"}`}
    </button>

    {error && <div className="error-message">{error}</div>}
    {succeeded && (
      <div className="success-message">✅ Donation successful!</div>
    )}
  </div>
  <Link className="stripe-link" to="https://stripe.com/">
    Processed By Stripe
  </Link>
</form>

  );
};

export default FundStripe;
